import { render, staticRenderFns } from "./PassportRadio.vue?vue&type=template&id=628eb040&scoped=true&"
import script from "./PassportRadio.vue?vue&type=script&lang=js&"
export * from "./PassportRadio.vue?vue&type=script&lang=js&"
import style0 from "./PassportRadio.vue?vue&type=style&index=0&id=628eb040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628eb040",
  null
  
)

export default component.exports